/**
 * Validated draft edits cannot add or remove line breaks. Pair each physical
 * line in a shared grid row so wrapping on either side cannot shift later prose.
 * Keep the original separators in the spans so text selection still round-trips.
 */
export function buildDraftEditRows(segments) {
  const rows = [];
  let row = [];
  for (const segment of segments) {
    if (segment.changed) {
      row.push(segment);
      continue;
    }
    let offset = 0;
    for (const match of segment.before.matchAll(/[^\r\n]*(?:\r\n|\r|\n)|[^\r\n]+$/g)) {
      const text = match[0];
      row.push({ ...segment, before: text, after: segment.after.slice(offset, offset + text.length) });
      offset += text.length;
      if (/[\r\n]$/.test(text)) {
        rows.push(row);
        row = [];
      }
    }
  }
  if (row.length) rows.push(row);
  return rows;
}
